module.exports = __webpack_public_path__ + "img/two_4.46b24369.png";